var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWarningWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3298 12.0839L8.83704 0.579684C8.74895 0.42719 8.58639 0.333608 8.40865 0.333069H8.2086C8.03085 0.333608 7.86446 0.42719 7.77012 0.579684L0.792979 12.0839C0.703154 12.2417 0.699242 12.4327 0.782607 12.5905L0.872824 12.7438C0.956001 12.9019 1.12077 12.9994 1.30107 12.9971H14.7843C14.9645 12.9994 15.1332 12.9019 15.2229 12.7438L15.3194 12.5905C15.4092 12.4327 15.4131 12.2417 15.3298 12.0839ZM8.77091 9.99771C8.76714 10.1818 8.61481 10.331 8.43067 10.331H7.76385C7.57971 10.331 7.43349 10.1818 7.43726 9.99771L7.45091 9.33118C7.45467 9.14713 7.607 8.99792 7.79114 8.99792H8.45796C8.6421 8.99792 8.78832 9.14713 8.78455 9.33118L8.77091 9.99771ZM8.50526 7.66486C8.59004 7.66548 8.66307 7.60237 8.67497 7.51823L8.98564 5.37201C8.99909 5.27693 8.97106 5.1815 8.90871 5.11005C8.84636 5.03861 8.7557 4.99807 8.65987 4.99876H7.75299C7.65719 4.99807 7.56488 5.03861 7.4996 5.11005C7.43432 5.1815 7.40238 5.27693 7.41194 5.37201L7.63472 7.51823C7.64317 7.60237 7.71362 7.66548 7.79843 7.66486H8.50526Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning_white.b6c43731.svg";
export { ForwardRef as ReactComponent };